export const _isNotEmpty = (obj) => {
   return !( obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype)
}

export const isEmpty = value =>
value === undefined ||
value === null ||
(typeof value === 'object' && Object.keys(value).length === 0) ||
(typeof value === 'string' && value.trim().length === 0);